import React, { useState } from 'react'
import Helmet from "react-helmet";
import { graphql } from "gatsby";
import Layout from '../../components/Layout'

const style = require("./index.module.css");

const PageStemwijzer = ({ data }) => {
  const page = data.page;
  const speerpunten = data.speerpunten;
  const speerpuntenPartijen = data.partijen;

  const [viewingSpeerpunt, setViewingSpeerpunt] = useState("");

  let stipStandpunten = null;
  let tegenstandersStandpunten = null;
  if(viewingSpeerpunt) {
    const partijenStandpunten = speerpuntenPartijen.group.filter((p) => p.nodes[0].speerpunt.id === viewingSpeerpunt)[0].nodes;
    stipStandpunten = partijenStandpunten.filter((p) => p.partij === "STIP")[0];
    tegenstandersStandpunten = partijenStandpunten.filter((p) => p.partij !== "STIP");
  }

  return (
    <Layout>
      <Helmet>
        <title>{page.title} · STIP</title>
      </Helmet>
      <div className="main-content" style={{paddingBottom: "2rem"}}>
        <div className="row">
          <div className="columns large-12">
          <h1>{page.pageTitle}</h1>
          <div
            dangerouslySetInnerHTML={{
              __html: page.text.childMarkdownRemark.html,
            }}
          />
          </div>
        </div>
        <div id="wijzer" className="row" style={{marginBottom: "1rem"}}>
          <div className="columns">
            {speerpunten.nodes.map(speerpunt => <button className={["small-12", style.speerpuntButton].join(" ")} key={speerpunt.id} onClick={() => {setViewingSpeerpunt(speerpunt.id); setTimeout(() => document.getElementById("wijzer").scrollIntoView(true), 50)}}>
              {speerpunt.title}
            </button>)}
          </div>
        </div>
        { viewingSpeerpunt && <div className="row">
          <div className="columns small-12 large-6">
            <div className={[style.partyBlock, style.partyStip].join(" ")} style={{'--background': `url('${speerpunten.nodes[0].icon.file.url}')`}}>
              <div className={style.partyLogo}>
                <img src="/images/logo/stip_logo_2021.svg"/>
              </div>
              <div dangerouslySetInnerHTML={{
                __html: stipStandpunten.standpunten.childMarkdownRemark.html,
              }} className={style.partyContent}></div>
            </div>
          </div>
          <div className="columns small-12 large-6">
            {
              tegenstandersStandpunten.map(tegenstander => (<div className={style.partyBlock} key={tegenstander.partij} style={{overflow: "auto", padding: "0.5rem 1rem"}}>
                <h2 className={style.partyTitle}>{tegenstander.partij}</h2>
                <div dangerouslySetInnerHTML={{
                  __html: tegenstander.standpunten.childMarkdownRemark.html,
                }}></div>
              </div>))
            }
          </div>
        </div>}
      </div>
    </Layout>
  )
}

export default PageStemwijzer

export const query = graphql`
  query($node_locale: String) {
    page: contentfulPage(slug: {eq: "stemwijzer"}, node_locale: {eq: $node_locale}) {
      title
      metaDescription
      pageTitle
      text {
        childMarkdownRemark {
          html
        }
      }
    }
    speerpunten: allContentfulSpeerpunt(
      filter: {node_locale: {eq: $node_locale}}
      sort: {order: ASC, fields: order}
    ) {
      nodes {
        id
        title
        icon {
          file {
            url
          }
        }
      }
    }
    partijen: allContentfulStemwijzerSpeerpunten(
      filter: {node_locale: {eq: $node_locale}}
      sort: {fields: partij, order: ASC}
    ) {
      group(field: speerpunt___id) {
        nodes {
          speerpunt {
            title
            id
          }
          partij
          standpunten {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    }
  }
`
